import React from "react";
import './integrations.css';

// ..... images .......
import intercom from '../../../assets/images/intercom.svg';
import freshdesk from '../../../assets/images/freshdesk.svg';
import zendesk from '../../../assets/images/zendesk.svg';
import marketo from '../../../assets/images/marketo.svg';
import slack from '../../../assets/images/slack.svg';
import notion from '../../../assets/images/notion.svg';
import hubspot from '../../../assets/images/hubSpot.svg';

function Integrations() {
   return(
       <div className="content-box width-900">
          <div className="title-font margin-b-30">Integrations</div>
          <div className="font-20 text-align-center">Floik works with all your favourite workflow apps</div>

          <ul className="integrations flex hr-space-between">
             <li className="integration-box support-box flex flex-wrap align-stretch vr-space-between">
                <div className="rubik-medium font-18">Support</div>
                <div className="icon integration-icon">
                   <div className="icon intercom width-140"><img src={intercom} alt=""/></div>
                </div>
                <div className="integration-icon">
                   <div className="icon freshdesk width-140"><img src={freshdesk} alt=""/></div>
                </div>
                <div className="icon integration-icon">
                   <div className="icon zendesk  width-80"><img src={zendesk} alt=""/></div>
                </div>
                <div className="font-16">plus more</div>
             </li>
             <li className="flex flex-wrap align-stretch vr-space-between">
                <div className="floik-box width-block">
                   <div className="floik rubik-bold">
                      <div className="">Floik</div>
                      <div className="dashed-line support"></div>
                      <div className="dashed-line marketing"></div>
                      <div className="dashed-line customer"></div>
                      <div className="dashed-line sales"></div>
                   </div>

                </div>
                <div className="marketing width-block integration-box flex flex-wrap vr-space-between">
                   <div className="rubik-medium font-18">Marketing</div>
                   <div className="integration-icon">
                      <div className="icon freshdesk width-120"><img src={marketo} alt=""/></div>
                   </div>
                   <div className="font-16">plus more</div>
                </div>
             </li>
             <li className="flex flex-wrap vr-space-between">
                <div className="customer width-block integration-box flex flex-wrap vr-space-between">
                   <div className="rubik-medium font-18">Customer Success</div>
                   <div className="integration-icon">
                      <div className="icon freshdesk width-130"><img src={slack} alt=""/></div>
                   </div>
                   <div className="integration-icon">
                      <div className="icon freshdesk width-130"><img src={notion} alt=""/></div>
                   </div>
                   <div className="font-16">plus more</div>
                </div>

                <div className="sales width-block integration-box flex flex-wrap vr-space-between">
                   <div className="rubik-medium font-18">Sales</div>
                   <div className="integration-icon">
                      <div className="icon freshdesk width-130"><img src={hubspot} alt=""/></div>
                   </div>
                   <div className="font-16">plus more</div>
                </div>
             </li>
          </ul>
       </div>
   )
}

export default Integrations;
